/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type ToggleReportFavoriteInput = {
    reportId: string;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type toggleReportFavoriteMutationVariables = {
    input: ToggleReportFavoriteInput;
};
export type toggleReportFavoriteMutationResponse = {
    readonly toggleReportFavorite: {
        readonly savedReport: {
            readonly node: {
                readonly id: string;
                readonly favorite: boolean | null;
            } | null;
        } | null;
    } | null;
};
export type toggleReportFavoriteMutation = {
    readonly response: toggleReportFavoriteMutationResponse;
    readonly variables: toggleReportFavoriteMutationVariables;
};



/*
mutation toggleReportFavoriteMutation(
  $input: ToggleReportFavoriteInput!
) {
  toggleReportFavorite(input: $input) {
    savedReport {
      node {
        id
        favorite
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "ToggleReportFavoriteInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ToggleReportFavoritePayload",
    "kind": "LinkedField",
    "name": "toggleReportFavorite",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SavedReportTypeEdge",
        "kind": "LinkedField",
        "name": "savedReport",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SavedReportType",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "favorite",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "toggleReportFavoriteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "toggleReportFavoriteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "toggleReportFavoriteMutation",
    "operationKind": "mutation",
    "text": "mutation toggleReportFavoriteMutation(\n  $input: ToggleReportFavoriteInput!\n) {\n  toggleReportFavorite(input: $input) {\n    savedReport {\n      node {\n        id\n        favorite\n      }\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'c8bb1a06d19b507c3228cdd0889ca145';
export default node;
